module.exports = __webpack_public_path__ + "static/media/WeGoTripLogo.29889ca1.svg";